// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-stress/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springStressEN: PageEntry = {
  id: "post.federbeanspruchung",
  locale: "en",
  slug: "spring-stress",
  seo: {
    title: "Glossary: Spring stress explained simply | Dietz GmbH",
    description: "Spring stress describes the forces and loads acting on a spring. Springs are typically stretched or compressed, which places stress on them. The stress on a spring depends on facto",
  },
  type: "post",
  h1: "Glossary: Spring stress explained simply",
  intro: "Spring stress describes the forces and loads acting on a spring. Springs are typically stretched or compressed, which places stress on them. The stress on a spring depends on factors such as the load, the spring constant and the spring geometry. Precisely calculating and analysing the stress is crucial to ensure the safe and efficient functioning of the spring in a given system. The selection of the right spring material also plays an important role in coping with different stresses.",
  blocks: [

  ],
};
